import styled from '@emotion/styled'
import { useEffect } from 'react'

import { Color, theme } from '../../../../constants'
import { Flex, Loader } from '../../../../elements'
import { useInView } from '../../../../hooks'

const FetchRow = styled.tr<{ canFetchMore: boolean }>(({ canFetchMore }) => ({
  background: Color.LIGHTER_BLUE,
  display: canFetchMore ? 'table-row' : 'none',
}))

type FetchMoreProps = {
  canFetchMore: boolean
  fetchMore: () => void
}

export const FetchMore = (props: FetchMoreProps) => {
  const [fetchMoreRef, isInView] = useInView<HTMLTableRowElement>()

  useEffect(() => {
    if (isInView && props.canFetchMore) props.fetchMore()
  }, [isInView])

  return (
    <FetchRow ref={fetchMoreRef} canFetchMore={props.canFetchMore}>
      <td colSpan={8}>
        <Flex
          items="center"
          styles={{
            height: theme.spacing['4'],
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Loader color={Color.BLUE} size="small" />
        </Flex>
      </td>
    </FetchRow>
  )
}
